import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import './NewMain.css'
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Selection,
  Inject,
  Edit,
  Toolbar,
  Sort,
  Filter,
  ColumnChooser
} from "@syncfusion/ej2-react-grids";

import { hotelGrid } from "../../data/dummy";
import { Header } from "../../components";
import CreateAddIcon from "../../data/createAddIcon.png"
import { BASE_URL, deleteCall, get } from "../../Services/Calls";
import { setGridVisibility, getGridVisibility } from '../../Services/gridVisibilityHelper';

const HotelsPrices = () => {

  const navigate = useNavigate()
  const FilterOptions = {
    type: 'Excel'
  };
  const selectionSettings = { checkboxOnly: true };
  const toolbarOptions = ["Delete", 'Search', 'ColumnChooser'];
  const [hotelData, setHotelData] = useState([])


  const [selectedRecords, setSelectedRecords] = useState([]) // Selected records to be deleted

  const [deleteConfirm, setDeleteConfirm] = useState(false)

  const editOptions = { allowEditing: false, allowAdding: true, allowDeleting: true };

  const [loading, setLoading] = useState(true);



  const gridRef = useRef(null);


  const pageKey = 'hotels-prices-page'; // unique key for each page
  const [isReady, setIsReady] = useState(false);
  const [columnSettings, setColumnSettings] = useState([]);
  useEffect(() => {
    const saved = getGridVisibility(pageKey);
    if (saved) setColumnSettings(saved);

    setIsReady(true);
  }, []);





  const finalColumns = hotelGrid.map((col) => {
    if (!col.field) return col; // Skip if no field (like checkbox/template)

    const match = columnSettings?.find((c) => c.field === col.field);
    return match
      ? { ...col, visible: match.visible }    // apply visibility state
      : { ...col };                           // fallback: visible by default
  });




  const onActionComplete = (args) => {
    if (args.requestType === 'columnstate') {
      const gridCols = gridRef.current?.getColumns() ?? [];
      const state = gridCols
        .filter((c) => !!c.field)
        .map((c) => ({
          field: c.field,
          visible: c.visible,
        }));
      setGridVisibility(pageKey, state);
    }
  };












  useEffect(() => {
    getHotelData()
  }, [])


  const getHotelData = async () => {
    setLoading(true);

    try {
      const response = await get(BASE_URL + "/hotels-prices-list");
      if (response && response.length > 0) {


          const saved =  localStorage.getItem("selectedCountry");
        if (saved) {
          const filteredResults = response.filter(item => String(item.country?.id) === String(saved));
          setHotelData(filteredResults);

        }
        else
        setHotelData(response)
      }
    }
    catch (ex) {
      alert(ex)
    }
    finally {
      setLoading(false);
    }
  };

  const toolbarClick = args => {
    switch (args.item.text) {
      case 'Delete':
        args.cancel = true;
        setDeleteConfirm(true)
        break
      default:
        break
    }
  }

  const handleDelete = async () => {
    setLoading(true);
    setDeleteConfirm(false)

    try {
      for (let i = 0; i < selectedRecords.length; i++) {
        const response = await deleteCall(
          BASE_URL + '/hotels-prices-list/' + selectedRecords[i].id
        )
        if (response) {

        }
      }

      getHotelData()



    }
    catch (ex) {
      alert(ex)
    }
  }



  const rowSelected = () => {
    if (gridRef.current) {
      const tempSelectedrecords = gridRef.current.getSelectedRecords()
      setSelectedRecords(tempSelectedrecords)
    }
  }

  const rowDeselected = args => {
    let tempSelectedRecords = [...selectedRecords]
    for (let i = 0; i < tempSelectedRecords.length; i++) {
      if (args.data.length > 1) {
        for (let j = 0; j < args.data.length; j++) {
          if (tempSelectedRecords[i].id == args.data[j].id) {
            tempSelectedRecords.splice(i, 1)
          }
        }
      } else {
        if (tempSelectedRecords[i].id == args.data.id) {
          tempSelectedRecords.splice(i, 1)
        }
      }
    }
    setSelectedRecords(tempSelectedRecords)
  }

  return (
    <div className="m-2 ml-10 mr-10 mt-5 p-2 p-5 bg-white rounded-3xl relative">
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div className="loader ease-linear rounded-full border-4 border-t-4 border-white h-12 w-12 animate-spin"></div>
        </div>
      )}
      <div className="flex justify-between items-center h-20">
        <Header category="" title="Hotel Price List" />
        <div style={{ width: 225 }} className="w-150 border flex justify-end items-center mb-8 createBtn" onClick={() => { navigate('/createHotel', { state: { from: 'create', data: {} } }) }}>
          <span>Add New Hotel</span>
          <img src={CreateAddIcon} style={{ width: 15, height: 15 }} alt="" />
        </div>
      </div>
      {isReady &&
        <GridComponent
          dataSource={hotelData}
          editSettings={editOptions}
          toolbar={toolbarOptions}
          filterSettings={FilterOptions}
          selectionSettings={selectionSettings}
          allowFiltering={true}
          showColumnChooser={true}
          allowPaging
          allowSorting
          pageSettings={{ pageCount: 5, pageSize: 10 }}
          toolbarClick={toolbarClick}
          rowSelected={rowSelected}
          rowDeselected={rowDeselected}
          ref={gridRef}
          actionComplete={onActionComplete}

        >
          <ColumnsDirective>
            {finalColumns.map((item, index) => (
              <ColumnDirective key={index} {...item} />
            ))}
          </ColumnsDirective>
          <Inject services={[Edit, Toolbar, Page, Filter, ColumnChooser]} />
        </GridComponent>
      }
      {deleteConfirm && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            background: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <div
            style={{
              width: 400,
              height: 200,
              background: '#fff',
              borderRadius: 10,
              padding: '15px 20px'
            }}
          >
            <div
              style={{
                fontSize: 24,
                fontWeight: 'bold',
                color: '#000',
                marginBottom: 15
              }}
            >
              Delete Alert
            </div>
            <div style={{ fontSize: 18, color: '#000', marginBottom: 10 }}>
              {selectedRecords.length > 0 ? "Are you sure you want to delete selected rows." : "Please select at-least one row."}
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                gap: 20
              }}
            >
              <div
                className='confirmOkBtn'
                onClick={() => {
                  getHotelData()
                  setDeleteConfirm(false)
                }}
              >
                {selectedRecords.length > 0 ? "Cancle" : "Ok"}
              </div>
              {selectedRecords.length > 0 &&
                <div
                  className='confirmOkBtn'
                  onClick={() => {
                    handleDelete()
                  }}
                >
                  Yes
                </div>
              }
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HotelsPrices;
